import { render } from "./TopAffiliates.vue?vue&type=template&id=2e77072b&scoped=true"
import script from "./TopAffiliates.vue?vue&type=script&lang=js"
export * from "./TopAffiliates.vue?vue&type=script&lang=js"

import "./TopAffiliates.vue?vue&type=style&index=0&id=2e77072b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e77072b"]])

export default __exports__